import {Component, HostListener, OnInit} from '@angular/core';
import {SectionComponent} from '../../elements/section/section.component';
import {MainVisitComponent} from './items/main-visit/main-visit.component';
import {MainDestinationsComponent} from './items/main-destinations/main-destinations.component';
import {MainBestHotelsComponent} from './items/main-best-hotels/main-best-hotels.component';
import {HeaderService} from '../../../services/header-service';
import {MainBusyBeeComponent} from './items/main-busy-bee/main-busy-bee.component';
import {SectionScrollerComponent} from '../../elements/section-scroller/section-scroller.component';
import {AccordionSliderComponent} from '../../elements/accordion-slider/accordion-slider.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Card, CardsArray, CardsArrayVoyagesNew} from '../../../model/cards';
import {Text} from '../../../model/text';
import {HotelDtoService} from '../../../services/hotel-dto-service';
import {PaginationParams} from '../../../model/pagination';
import {NgIf} from '@angular/common';
import {environment} from '../../../environments/environment';
import {Continent} from '../../../model/circle';
import {ThemeService} from '../../../services/theme.service';
import {getFirstSentence} from '../../../functions/getFirstSentence';
import {MenuService} from '../../../services/menu-services';
import {LoadingService} from '../../../services/loading-service';
import {catchError, finalize, of, timeout} from 'rxjs';

@Component({
  selector: 'app-main',
  imports: [
    MainVisitComponent,
    MainDestinationsComponent,
    SectionComponent,
    MainBestHotelsComponent,
    MainBusyBeeComponent,
    SectionScrollerComponent,
    AccordionSliderComponent,
    NgIf,
  ],
  templateUrl: './main.component.html',
  standalone: true,
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit {
  constructor(protected interfaceService: HeaderService,
              private route: ActivatedRoute,
              private router: Router,
              private hotelService: HotelDtoService,
              public themeService: ThemeService,
              protected menuService: MenuService,
              public loadingService: LoadingService,) {
  }

  hotels: Card[] = [];
  loadingHotels: boolean = false;
  loadingVisit: boolean = false;
  loadingCircle: boolean = false;
  loading: boolean = false;
  isMobile: boolean = false;

  mainBestHotelsTitle: Text[] = [
    {text: ['Лучшие ', ' ']},
    {text: ['отели ', 'FINEST '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['мира', 'Hotels']}
  ];
  mainBusyBeeTitle: Text[] = [
    {text: ['Корпоративным ', 'Corporate & '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['клиентам', 'Business ']},
    {text: ['', 'Travel']}
  ];
  mainVoyagesTitle: Text[] = [
    {text: ['Путешествуйте  ', 'Discover '], fontFamily: 'pd', fontStyle: 'italic'},
    {text: ['с нами', 'THE WORLD ']},
  ];

  hotelList: PaginationParams = new PaginationParams({
    query: '',
    pageSize: 10,
    pageNumber: 0,
    sort: 'rating:asc',
    cityId: '',
    countryId: '',
    continentId: '',
  });

  ngOnInit() {
    // The first screen has a local background; secondary sections must not hide it.
    this.loadingService.setLoadingValue(false);
    if (window.innerWidth <= 570) {
      this.isMobile = true;
    }
    this.loadingHotels = true;
    this.menuService.setMobileStyle('transparent');
    this.hotelService.getHotelList(this.hotelList).pipe(
      timeout(12000),
      catchError(() => of({content: []})),
      finalize(() => {
        this.loadingHotels = false;
        this.checkLoading();
      })
    ).subscribe((data) => {
      this.hotels = (data.content ?? []).map(v => {
        const path = v.image ? (environment.s3Prefix + v.image) : '/app/assets/images/hotel.png';
        let descrRu = '';
        let descrEn = '';
        if (v.descriptionRu !== undefined) {
          descrRu = getFirstSentence(v.descriptionRu);
        }
        if (v.descriptionEn !== undefined) {
          descrEn = getFirstSentence(v.descriptionEn);
        }
        const link = v.city?.country?.continent?.url + '/' + v.city?.country?.url + '/' +
          v.city?.url + '/' + v?.url;
        return new Card(
          {
            title: ['', ''],
            text: [v.titleRu, v.titleEn],
            img: path,
            style: v.backgroundStyle?.toString() ?? '',
            link: link,
            rating: v.rating ?? 0,
            anotherButtonText: [{text: [descrRu, descrEn]}],
          },
        )
      });
      this.loadingHotels = false;
    });

    this.interfaceService.setPageInterface('header-transparent');
    if (window.innerWidth < 770) {
      this.mainBusyBeeTitle = [
        {text: ['FOR ', 'FOR ']},
        {text: ['Busy Bee’s', 'Busy Bee’s'], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
      ];
      this.mainBusyBeeTitle = [
        {text: ['Корпоративным ', ' '], fontFamily: 'pd', fontStyle: 'italic'},
        {text: ['клиентам', 'Business ']},
        {text: ['', 'Travel']}
      ];
      // this.mainVoyagesTitle = [
      //   {text: ['Exclusive ', 'Exclusive '], textTransform: 'uppercase'},
      //   {text: ['Voyages', 'Voyages'], fontFamily: 'pd', fontStyle: 'italic', textTransform: 'uppercase'},
      // ]
    }
  }

  onWindowScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const deviceHeight = window.innerHeight;
    if (currentScrollTop > deviceHeight - 65) {
      this.menuService.setMobileStyle('white')
    } else {
      this.menuService.setMobileStyle('transparent');
    }
  }

  visitEmit(event: boolean) {
    this.loadingVisit = event;
    this.checkLoading();
  }

  circleEmit(event: boolean) {
    this.loadingCircle = event;
    this.checkLoading();
  }

  checkLoading() {
    this.loading = this.loadingVisit || this.loadingHotels || this.loadingCircle;
  }

  goToDestination(continent: Continent) {
    const url = 'destinations/' + continent.url?.toLowerCase().replaceAll(" ", "-");
    this.router.navigate([url], {relativeTo: this.route}).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }

  protected readonly CardsArray = CardsArray;
  protected readonly CardsArrayVoyagesNew = CardsArrayVoyagesNew;
  protected readonly window = window;
}
